import HttpService from "@/modules/core/network/http-service";

class DonateService extends HttpService {
  constructor() {
    super("donate");
  }
}

export default new DonateService();
